import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  Brush,
  ComposedChart,
  LabelList,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { MaskValor } from '../../../../../component';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { labelFormatterNumber } from '../../../../../shared/formatters/formatters';
import { RealtyAnnouncedByPeriodChartData } from './types';

export const RealtyAnnouncedByPeriod: React.FC = () => {
  const { requestStatusSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  const { chartsDataSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  return (
    <ChartCard
      data={chartsDataSecondary['realty_announced_by_period']}
      Chart={RealtyAnnouncedByPeriodChart}
      cy={'RealtyAnnouncedByPeriod'}
      id={'realtyAnnouncedByPeriod'}
      requestStatus={requestStatusSecondary['realtyAnnouncedByPeriod']}
    />
  );
};

const RealtyAnnouncedByPeriodChart: React.FC<
  IChartProps<RealtyAnnouncedByPeriodChartData[]>
> = ({ data, cy, id }) => {
  const { realty_announced_by_period_mean } = useSelector(
    (state: any) => state.offersSecondaryState.chartsDataSecondary
  );
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterNumber, labelFormatterNumber];
  const key: () => string = () => {
    switch (data[0]['type' as keyof (typeof data)[0]]?.toString()) {
      case 'year':
        return 'average_years';
      case 'quarter':
        return 'average_quarters';
      case 'month':
        return 'average_months';
      default:
        return '';
    }
  };

  const average = realty_announced_by_period_mean
    ? realty_announced_by_period_mean[key()]
    : '';

  return (
    <ResponsiveContainer data-cy={`RealtyOffersByPeriod${cy}`}>
      <ComposedChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <XAxis dataKey="id" />
        <YAxis />
        <Bar
          isAnimationActive={false}
          name="Anúncios por período"
          dataKey="value"
          fill="#8884d8"
        >
          <LabelList
            dataKey="value"
            position="top"
            formatter={(v: any) => MaskValor(v)}
          />
        </Bar>
        <Legend iconType="circle" />
        <Line
          isAnimationActive={false}
          dataKey={() => average}
          name="Média de anúncios"
          stroke="red"
        />
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
